import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogTitle } from '@headlessui/react';

import Button from '../../../widgets/Button';
import Modal from '../../../widgets/Modal';
import { handleFailHide } from '../toast';
import reportStatus from '../../../../assets/icons/report-status.png';
import { Contact } from '../../../../shared/constants/contact';

interface IReportModals {
  open: boolean;
  setReportfail: (value: boolean) => void;
}

function ReportFailed({ open, setReportfail }: IReportModals) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      handleClose={() => {
        setReportfail(false);
        handleFailHide();
      }}
      modalClassName="w-[400px]"
      closeButton
    >
      <div className="grid justify-normal pt-[22px] text-center">
        <img src={reportStatus} className="m-auto mb-[34px] w-[142px]" alt="" />
        <DialogTitle
          as="h4"
          className="text-black-900 mb-2 text-lg font-semibold"
        >
          {t('REPORT_FAIL_HEADING')}
        </DialogTitle>
        <p className="text-black-600 mb-2 text-sm">
          {t('REPORT_FAIL_SUBHEADING')}
        </p>
        <p className="text-primary-600 mb-4 text-sm font-semibold">
          <a href={`mailto:${Contact.Email}`}>{Contact.Email}</a>
        </p>
        <Button
          size="lg"
          onClick={() => {
            setReportfail(false);
            handleFailHide();
          }}
        >
          {t('OKAY')}
        </Button>
      </div>
    </Modal>
  );
}

export default ReportFailed;
